'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeight = exports.fontFamily = exports.lineHeight = exports.fontSize = undefined;

var _dictionary = require('../dictionary');

var _dictionary2 = _interopRequireDefault(_dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('../variables.json'),
    $fontSizeMap = _require.$fontSizeMap,
    $lineHeightMap = _require.$lineHeightMap,
    $fontFamilyMap = _require.$fontFamilyMap,
    $fontWeightMap = _require.$fontWeightMap;
// Font-size map
// -----------------------------------------------------------------------------
// NOTE: The root font size sets the scale for your stack. Please use pixels or
//       a percentage unit for the value. Base font size should always be 1rem.
//
// Example use:
// .class {
//   font-size: fontSize('h2');
// }
// -----------------------------------------------------------------------------
// =============================================================================
// TYPOGRAPHY (Settings)
// =============================================================================


var fontSize = exports.fontSize = (0, _dictionary2.default)($fontSizeMap, 'Unknown fontSize used in fontSize function');
// Line-height map
// -----------------------------------------------------------------------------
// Example use:
// .class {
//   line-height: lineHeight('h2');
// }
// -----------------------------------------------------------------------------
var lineHeight = exports.lineHeight = (0, _dictionary2.default)($lineHeightMap, 'Unknown lineHeight used in lineHeight function');
// Font-family map
// -----------------------------------------------------------------------------
// Example use:
// .class {
//   font-family: fontFamily('heading');
// }
// -----------------------------------------------------------------------------
var fontFamily = exports.fontFamily = (0, _dictionary2.default)($fontFamilyMap, 'Unknown fontFamily used in fontFamily function');
// Font-weight map
// -----------------------------------------------------------------------------
// Example use:
// .class {
//   font-weight: fontWeight('bold');
// }
// -----------------------------------------------------------------------------
var fontWeight = exports.fontWeight = (0, _dictionary2.default)($fontWeightMap, 'Unknown fontWeight used in fontWeight function');
//# sourceMappingURL=type.js.map